export interface BlockProps {
  sys: {
    id: string;
  };
  title?: string;
  layout: string;
  backgroundColor?: string;
  splitRatio?: string;
  leftBlock?: BlockProps;
  rightBlock?: BlockProps;
  showTitle?: boolean;
  padding?: string;
  feature?: string;
  carouselType?: string;
  gridColumns?: number;
  showBackgroundIcon: boolean;
  underline?: boolean;
  anchor?: string;
  carouselCollection?: {
    items: PageProps[];
  };
  heroBackground?: {
    url: string;
  };
  heroDescription?: {
    json: any;
  };
  cardImage?: {
    url: string;
  };
  handle?: string;
  seoTitle?: string;
  seoDescription?: string;
  blocksCollection?: {
    items: BlockProps[];
  };
  contentfulMetadata?: {
    tags: any[];
  };
  isBlock?: boolean;
  openInNewTab?: boolean;
  imageCarousel?: any;
  description?: {
    json: any;
  };
}

export interface PageProps {
  sys: {
    id: string;
  };
  title: string;
  handle: string;
  cardImage?: {
    url: string;
  };
  contentfulMetadata?: {
    tags: any[];
  };
  text?: {
    json: any;
  };
}

export type CookieConsent = {
  analytics: boolean;
  lastUpdated: number;
};

export enum DocumentType {
  PDF = "pdf",
  WEBPAGE = "webpage",
  PDF_URL = "pdf_url",
}

export interface Chunk {
  id: string;
  text: string;
  metadata: DocumentMetadata;
  embedding?: number[];
}

export interface DocumentMetadata {
  documentId: string;
  documentType: DocumentType;
  title: string;
  url?: string;
  pageNumber?: number;
  createdAt: Date;
  contentfulEntryId?: string; // Contentful entry ID for webhook-based deletion
  tags?: string[]; // Tags from Contentful metadata for filtering
}

export interface SearchResult {
  id: string;
  text: string;
  score: number;
  rawScore?: number; // Original highest score before combining with chunk count
  matchCount?: number; // Number of chunks that matched the query
  metadata: DocumentMetadata;
  chunks?: Array<{
    id: string;
    text: string;
    score: number;
    metadata: any;
  }>;
}

export interface SearchParams {
  query: string;
  limit?: number;
}
